export const RESPONSIVE_SIZE = {
	SM: 640,
	MD: 768,
	LG: 1024,
	XL: 1280,
	XL2: 1536,
};
